import { withIntegrationApp } from 'src/hocs/withIntegrationApp';
import { useWizard } from '../components/wizard/WizardContext';
import { Heading } from 'src/components/Heading';
import { Button } from 'src/components/Button';
import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { OutboundConfigurations } from './CampaignOverview/components/OutboundConfigurations';
import { CampaignSettings } from './CampaignOverview/components/CampaignSettings';
import { CommunicationChannel } from 'src/services/campaigns/campaigns.interface';

const ConfigureSettings = () => {
  const navigate = useNavigate();
  const {
    currentStep,
    prevStep,
    nextStep,
    campaignAutomation,
    saveCampaignAutomation,
  } = useWizard();

  const hasEmailFollowup = useMemo(
    () =>
      campaignAutomation.followUpCommunications.some(
        (c) => c.contactVia === CommunicationChannel.EMAIL,
      ),
    [campaignAutomation.followUpCommunications],
  );

  const hasSmsFollowup = useMemo(
    () =>
      campaignAutomation.followUpCommunications.some(
        (c) => c.contactVia === CommunicationChannel.SMS,
      ),
    [campaignAutomation.followUpCommunications],
  );

  const canContinue = useMemo(() => {
    const hasFromNumbers = campaignAutomation.fromNumberOptions.length > 0;
    let emailValid = true;
    if (hasEmailFollowup) {
      const hasEmailProvider = Boolean(
        campaignAutomation.emailProviderOption?.value,
      );
      const hasFromEmail =
        (campaignAutomation.fromEmail || '').trim().length > 0;
      emailValid = hasEmailProvider && hasFromEmail;
    }

    let smsValid = true;
    if (hasSmsFollowup) {
      const hasSmsProvider = Boolean(
        campaignAutomation.smsProviderOption?.value,
      );
      const hasFromNumber =
        (campaignAutomation.smsFromNumber || '').trim().length > 0;
      smsValid = hasSmsProvider && hasFromNumber;
    }
    return hasFromNumbers && emailValid && smsValid;
  }, [
    campaignAutomation.fromNumberOptions.length,
    campaignAutomation.emailProviderOption,
    campaignAutomation.fromEmail,
    campaignAutomation.smsProviderOption,
    campaignAutomation.smsFromNumber,
    hasEmailFollowup,
    hasSmsFollowup,
  ]);

  const handleSaveAndExit = async () => {
    const campaignSaved = await saveCampaignAutomation();
    if (campaignSaved) navigate('/beta/campaigns');
  };

  return (
    <div className="flex-1">
      <Heading
        title="Configure your settings"
        subtitle={`${currentStep}/3`}
        backAction={prevStep}
      >
        <div className="flex gap-2 mt-3">
          <Button variant="outlined" size="small" onClick={prevStep}>
            Back
          </Button>
          <Button variant="outlined" size="small" onClick={handleSaveAndExit}>
            Save & Exit
          </Button>
          <Button size="small" onClick={nextStep} disabled={!canContinue}>
            Next
          </Button>
        </div>
      </Heading>
      <div className="p-4 flex justify-center">
        <div className="w-full flex flex-col max-w-[850px] space-y-6 gap-6">
          <OutboundConfigurations />
          <CampaignSettings />
        </div>
      </div>
    </div>
  );
};

export default withIntegrationApp(ConfigureSettings);
